module.exports = __webpack_public_path__ + "img/categories_bg.6ced39db.svg";